import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Search, Sensors } from "@usereactify/search";
import { InstantSearch } from "../components/InstantSearch/InstantSearch";

const ReactifySearchFactory = new ReactifySearchLiquidFactory({
  mode: "instant-search",
  shopifyPermanentDomain: "remarkable-outdoor-living.myshopify.com",
});
const ReactifySearchProvider = ReactifySearchFactory.getProvider();
const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
ReactDOM.render(
  <React.StrictMode>
    <ReactifySearchProvider>
      <Sensors />
      <InstantSearch />
    </ReactifySearchProvider>
  </React.StrictMode>,
  ReactifySearchMountNode
);
